import { baseToApiShape, baseFromApiShape, baseInitNewForm, baseInitEditForm } from '../formHelpers/base';

/**
 * IBM has no provider-specific fields beyond the shared base.
 * These thin wrappers maintain the per-provider API contract.
 */

export function toApiShape(form) {
    const base = baseToApiShape(form);
    return {
        ...base,
        info: {
            ...base.info,
            // IBM is unified-only. The unified template resolves the head (and compute)
            // image from unified_image_id when set, otherwise from the image_name prefix
            // (newest "<prefix>-heidi-<ts>"). So pinning a specific captured version or a
            // cloud image by id MUST go through unified_image_id - a full image name in
            // image_name would not match the "<name>-heidi-" pattern and the deploy fails
            // with "oneOf got 0". serverImageId holds that pinned id; empty -> newest.
            unifiedImageId: form.serverImageId || null,
        },
        data: {
            ...base.data,
            network: {
                ...base.data.network,
                capacity_reservation_parallel_deployment: form.capacityReservationParallelDeployment ?? false,
            },
        },
    };
}

export function fromApiShape(cluster) {
    return {
        ...baseFromApiShape(cluster),
        // Prefer the pinned unified image id (how IBM pins a version) over the legacy
        // server.image_id so an edit round-trips the selected version.
        serverImageId: cluster.info?.unifiedImageId || cluster.data?.server?.image_id || '',
        capacityReservationParallelDeployment: cluster.data?.network?.capacity_reservation_parallel_deployment ?? false,
    };
}

export function initNewForm(provider, config) {
    return {
        ...baseInitNewForm(provider, config),
        capacityReservationParallelDeployment: config.clusterSettings?.fastCapacityValidationDefault === true,
    };
}

export function initEditForm(cluster, config) {
    return {
        ...baseInitEditForm(cluster, config),
        capacityReservationParallelDeployment: cluster.data?.network?.capacity_reservation_parallel_deployment ?? false,
    };
}
